import './Rodape.css'

const Rodape = () => {
    return (<footer className="footer">
        <section>
            <ul>
                <li>
                    <a href="https://github.com/Bonilhajvv" target="_blank" rel="noopener noreferrer" >
                        <img src="/imagens/gitHub.png" alt="GitHub conta pessoal" width={40} />
                    </a>
                </li>
                <li>
                    <a href="https://www.linkedin.com/in/jo%C3%A3o-victor-bonilha-venturini-17311a1b9/" target="_blank" rel="noopener noreferrer" >
                        <img src="/imagens/lk.png" alt="Linkedin conta pessoal" width={35} />
                    </a>
                </li>
                <li>
                    <a href="https://www.instagram.com/Bonilha_0/" target="_blank" rel="noopener noreferrer" >
                        <img src="/imagens/ig.png" alt="Instagram conta pessoal" />
                    </a>
                </li>
            </ul>
        </section>
        <section>
            <img src="/imagens/logo.png" alt="" />
        </section>
        <section>
            <p>
                Desenvolvido por Bonilha.
            </p>
        </section>
    </footer>)
}

export default Rodape